import { Badge, BadgeProps } from '@givebutter/primitives/badge';
import { maskWholeNumber } from '@givebutter/util';
import { twMerge } from 'tailwind-merge';

interface CountBadgeProps extends Omit<BadgeProps, 'variant'> {
    count: number | null | undefined;
}

const CountBadge = ({ count, size, color, className, ...rest }: CountBadgeProps) => {
    if (typeof count !== 'number') {
        return null;
    }

    return (
        <Badge
            size={size}
            color={color}
            className={twMerge(
                'group-hover/navlink:text-inherit group-hover:text-inherit',
                className,
            )}
            {...rest}
        >
            {maskWholeNumber(count)}
        </Badge>
    );
};

export { CountBadge };
